<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Watching Cars Go By</span></p>
<p class="p0">By D.J. Fronimos and Elke Lakey</p>
<p class="p2"><a id="a3"></a><a href="#/005#a57">Chapter 1: Silke</a></p>
<p class="p2"><a href="#/006#a58">Chapter 2: Lauren</a></p>
<p class="p2"><a href="#/007#a59">Chapter 3: Silke</a></p>
<p class="p2"><a href="#/008#a60">Chapter 4: Lauren</a></p>
<p class="p2"><a href="#/009#a61">Chapter 5: Silke</a></p>
<p class="p2"><span href="#/010#a62" title="Link target outside of Sample">Chapter 6: Lauren</span></p>
<p class="p2"><span href="#/011#a63" title="Link target outside of Sample">Chapter 7: Silke</span></p>
<p class="p2"><span href="#/012#a64" title="Link target outside of Sample">Chapter 8: Silke</span></p>
<p class="p2"><span href="#/013#a65" title="Link target outside of Sample">Chapter 9: Ana</span></p>
<p class="p2"><span href="#/014#a66" title="Link target outside of Sample">Chapter 10: Silke</span></p>
<p class="p2"><span href="#/015#a67" title="Link target outside of Sample">Chapter 11: Ana</span></p>
<p class="p2"><span href="#/016#a68" title="Link target outside of Sample">Chapter 12: Lauren</span></p>
<p class="p2"><span href="#/017#a69" title="Link target outside of Sample">Chapter 13: Silke</span></p>
<p class="p2"><span href="#/018#a70" title="Link target outside of Sample">Chapter 14: Lauren</span></p>
<p class="p2"><span href="#/019#a71" title="Link target outside of Sample">Chapter 15: Ana</span></p>
<p class="p2"><span href="#/020#a72" title="Link target outside of Sample">Chapter 16: Lauren</span></p>
<p class="p2"><span href="#/021#a73" title="Link target outside of Sample">Chapter 17: Lauren</span></p>
<p class="p2"><span href="#/022#a74" title="Link target outside of Sample">Chapter 18: Silke</span></p>
<p class="p2"><span href="#/023#a75" title="Link target outside of Sample">Chapter 19: Lauren</span></p>
<p class="p2"><span href="#/024#a76" title="Link target outside of Sample">Chapter 20: Silke</span></p>
<p class="p2"><span href="#/025#a77" title="Link target outside of Sample">Chapter 21: Lauren</span></p>
<p class="p2"><span href="#/026#a78" title="Link target outside of Sample">Chapter 22: Ana</span></p>
<p class="p2"><span href="#/027#a79" title="Link target outside of Sample">Chapter 23: Lauren</span></p>
<p class="p2"><span href="#/028#a80" title="Link target outside of Sample">Chapter 24: Silke</span></p>
<p class="p2"><span href="#/029#a81" title="Link target outside of Sample">Chapter 25: Ana</span></p>
<p class="p2"><span href="#/030#a82" title="Link target outside of Sample">Chapter 26: Lauren</span></p>
<p class="p2"><span href="#/031#a83" title="Link target outside of Sample">Chapter 27: Silke</span></p>
<p class="p2"><span href="#/032#a84" title="Link target outside of Sample">Chapter 28: Lauren</span></p>
<p class="p2"><span href="#/033#a85" title="Link target outside of Sample">Chapter 29: Silke</span></p>
<p class="p2"><span href="#/034#a86" title="Link target outside of Sample">Chapter 30: Lauren</span></p>
<p class="p2"><span href="#/035#a87" title="Link target outside of Sample">Chapter 31: Silke</span></p>
<p class="p2"><span href="#/036#a88" title="Link target outside of Sample">Chapter 32: Lauren</span></p>
<p class="p2"><span href="#/037#a89" title="Link target outside of Sample">Chapter 33: Ana</span></p>
<p class="p2"><span href="#/038#a90" title="Link target outside of Sample">Chapter 34: Silke</span></p>
<p class="p2"><span href="#/039#a91" title="Link target outside of Sample">Chapter 35: Lauren</span></p>
<p class="p2"><span href="#/040#a92" title="Link target outside of Sample">Chapter 36: Silke</span></p>
<p class="p2"><span href="#/041#a93" title="Link target outside of Sample">Chapter 37: Lauren</span></p>
<p class="p2"><span href="#/042#a94" title="Link target outside of Sample">Chapter 38: Ana</span></p>
<p class="p2"><span href="#/043#a95" title="Link target outside of Sample">Chapter 39: Lauren</span></p>
<p class="p2"><span href="#/044#a96" title="Link target outside of Sample">Chapter 40: Silke</span></p>
<p class="p2"><span href="#/045#a97" title="Link target outside of Sample">Chapter 41: Ana</span></p>
<p class="p2"><span href="#/046#a98" title="Link target outside of Sample">Chapter 42: Silke</span></p>
<p class="p2"><span href="#/047#a99" title="Link target outside of Sample">Chapter 43: Lauren</span></p>
<p class="p2"><span href="#/048#a100" title="Link target outside of Sample">Chapter 44: Lauren</span></p>
<p class="p2"><span href="#/049#a101" title="Link target outside of Sample">Chapter 45: Silke</span></p>
<p class="p2"><span href="#/050#a102" title="Link target outside of Sample">Chapter 46: Lauren</span></p>
<p class="p2"><span href="#/051#a103" title="Link target outside of Sample">Chapter 47: Silke</span></p>
<p class="p2"><span href="#/052#a104" title="Link target outside of Sample">Chapter 48: Lauren</span></p>
<p class="p2"><span href="#/053#a105" title="Link target outside of Sample">Chapter 49: Silke</span></p>
<p class="p2"><span href="#/054#a106" title="Link target outside of Sample">Chapter 50: Silke</span></p>
<p class="p2"><span href="#/055#a107" title="Link target outside of Sample">Chapter 51: Lauren</span></p>
<p class="p2"><span href="#/056#a108" title="Link target outside of Sample">Chapter 52: Silke</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?f0946002